import React from "react";
import { FieldProps } from "formik";

const CheckboxComponent: React.FC<FieldProps> = (props) => {
  const { field } = props;

  return <input type="checkbox" checked={field.value} {...field} />;
};

export default CheckboxComponent;
